import actions from './actions'
import mutations from './mutations'

const business = {
    namespaced: true,
    state: {
        leaders: [],
        filters: {
            businessId: null,
            fromDate: null,
            toDate: null,
            leader: null,
            businessEmail: null,
            query: null
        },
        isLoaded: false,
        items: [],
        pagination: {
            page: 1,
            length: null,
            total: null
        }
    },
    actions,
    mutations
}

export default business
